<template>
  <div class="screen settings" :class="[`${pageColor}-bg`]">
    <h1>adjust rhythm to your needs.</h1>
    <!-- download app-->
    <ul class="info" @click="install">
      <li>
        <button>
          <TodoIcon class="buttonicon" :icon="'download'"/>
        </button>
      </li>
      <li> <p>install and use offline</p> </li>
    </ul>
    <!--change username-->
    <ul class="info" @click="handleEditName">
      <li>
        <button>
          <TodoIcon class="buttonicon" :icon="'name'"/>
        </button>
      </li>
      <li> <p>change name</p> </li>
    </ul>

    <ul class="info" @click="$store.commit('addToast', {message: 'headline Font Operetta 8 is by Synthview Type Design and body font futura-pt by Paratype.', timeout: 5000, actionLabel: 'close'})">
      <li>
        <button>
          <TodoIcon class="buttonicon" :icon="'credits'"/>
        </button>
      </li>
      <li> <p>credits</p> </li>
    </ul>

    <ul class="info" @click="$store.commit('addToast', {message: 'Design and code by alina karl. For problems or suggestions contact: mail@alinakarl.com.', timeout: 7000, actionLabel: 'close'})">
      <li>
        <button>
          <TodoIcon class="buttonicon" :icon="'mail'"/>
        </button>
      </li>
      <li> <p>contact</p> </li>
    </ul>

    <ul class="info" @click="$store.commit('addToast', {message: 'This app has been developed in the webdesign2 course of amadeus stadler at UAS munich. thank you for all your help!', timeout: 7000, actionLabel: 'close'})">
      <li>
        <button>
          <TodoIcon class="buttonicon" :icon="'heart'"/>
        </button>
      </li>
      <li> <p>Acknowledgement</p> </li>
    </ul>
    <!-- the change username modal-->
    <TodoNameModal title="edit name" :visible="showNameModal" @close="showNameModal = false" @confirm="saveUserName"/>
  </div>
</template>

<script>

import TodoIcon from '@/components/TodoIcon.vue';
import TodoNameModal from '@/components/TodoNameModal.vue';

export default {
  name: 'settings',
  components: {
    TodoIcon,
    TodoNameModal,
  },
  created() {
    this.name = this.$store.state.settings.name; // loads username
  },
  data() {
    return {
      name: '',
      showNameModal: false,
    };
  },
  methods: {
    handleEditName() {
      this.showNameModal = true; // shows modal
    },
    saveUserName() {
      if (this.name.length === 0) {
        this.$store.commit('addToast', { message: 'Sorry. This name is too short.' });
      } else {
        this.$store.dispatch('addName', this.name);
        this.$store.commit('addToast', { message: 'Your name has been edited.' });
        this.showNameModal = false;
      }
    },
    install() {
      this.$store.commit('addToast', {
        action: async () => {
          // open installation dialogue
          this.$store.state.installPrompt.prompt();
          // answer of the user in userChoice
          const choice = await this.$store.state.installPrompt.userChoice;

          if (choice.outcome === 'accepted') {
            this.$store.commit('addToast', {
              message: 'Rhythm should have been added to your homescreen or desktop. You can now launch it from there and close this tab.',
            });
          } else {
            this.$store.commit('addToast', { message: 'Okay, if you want to install rhythm later you can always download it in your settings.' });
          }
        },
        actionLabel: 'yes',
        message: 'sure?',
        timeout: -1,
      });
    },
  },
  props: {
    pageColor: String,
    actionLabel: String,
  },
};
</script>

<style lang="stylus" scoped>

@require '../assets/styles/breakpoints'

.screen
  background-image: linear-gradient(150deg, #C9D9D6, #C9D9D6, white, #C9D9D6, #C9D9D6)

  @media $desktop
    background-image: linear-gradient(-7deg, #C9D9D6, #C9D9D6, white, #C9D9D6, #C9D9D6)

  &.v-enter-active,
  &.v-leave-active
    transition: filter 80ms ease

    &.v-enter,
    &.v-leave-to
      filter: blur(1px);

  .info
    border-top: 1px solid black
    background-color: transparent
    height: 60px
    color: black
    margin: 0px

    .actionLabel
      color: white

    &:focus
      color: white
      background-color: black

    &:active
      color: white
      background-color: black

    &:hover
      color: white
      background-color: black

      .buttonicon
        color: white

    li
      display: inline-block
      vertical-align: middle
      padding-top: 3px
      font-family: futura-pt, serif
      font-weight: 400
      font-style: normal
      text-transform: uppercase
      font-size: 16px

    p
      font-family: futura-pt, serif
      font-weight: 400
      font-style: normal
      text-transform: uppercase

      @media $tablet
        margin-left: 60px

    button
      border: none
      color: black
      background-color: transparent
      outline: none
      width: 100%
      font-family: futura-pt, serif
      font-weight: 400
      font-style: normal
      text-transform: uppercase

      @media $tablet
        margin-left: 110px

      .buttonicon
        color: black
        padding-top: 7px

      &:focus
        color: white
        background-color: transparent
        border: none
        outline: none

      &:active
        color: white
        background-color: transparent
        border: none
        outline: none

      &:hover
        color: white
        background-color: transparent
        border: none
        outline: none

</style>
